import { SelfTestAnswers } from "../../../../components/self-test/model/SelfTestAnswers";

export const result = (answers: SelfTestAnswers) => {
    let risk = false;
    for(const v of Object.values(answers)) {
        if (v === 'yes') {
            risk = true;
            break;
        }
    }

    return { risk };
}